import { Icon, SvgCode } from '@loomhq/lens';
import React, { Component } from 'react';

class EmbedCodeDropdownItem extends Component {
  render() {
    return (
      <li
        className="share-video-embed-code-dropdown-item"
        onClick={this.props.onClick}
      >
        <Icon icon={<SvgCode />} size="1rem" />
        <span>Embed</span>
      </li>
    );
  }
}

export default EmbedCodeDropdownItem;
